'use strict';

const IframeLogin = window.IframeLogin || {};

IframeLogin.openModal = function(path = window.location.href) {
  this.destination = path;
  window.GIG.Modal.open({
    el: this.$modal,
  });
  return __guardMethod__(
    __guard__(
      frames[this.iframeName] != null
        ? frames[this.iframeName].IframeLogin
        : undefined,
      x => x.iframeView
    ),
    'resetHeight',
    o => o.resetHeight()
  );
};

function __guardMethod__(obj, methodName, transform) {
  if (
    typeof obj !== 'undefined' &&
    obj !== null &&
    typeof obj[methodName] === 'function'
  ) {
    return transform(obj, methodName);
  } else {
    return null;
  }
}

function __guard__(value, transform) {
  return typeof value !== 'undefined' && value !== null
    ? transform(value)
    : undefined;
}
